import services from 'services/module';
import SpinnerSvc from 'services/SpinnerSvc';
import { TagsSvc } from './TagsSvc';
import { HttpSvcFactory } from './HttpSvc';
import { BackendSvc } from './BackendSvc';
import { Utils } from '../underscore-extensions';
import { PROJECT_ADD } from './AnimatronProjectsSvc';
import { TranslateSvc } from './TranslateSvc';

export type AdminSvcFactory = new (project: anm.Project) => AdminSvc;

export class AdminSvc {
    private $http: ng.IHttpService;
    private $q: ng.IQService;
    private TagsSvc: TagsSvc;
    private HttpSvc: HttpSvcFactory;
    private BackendSvc: BackendSvc;
    private $rootScope: ng.IRootScopeService;
    private TranslateSvc: TranslateSvc;

    exportActions = ['json', 'anm', 'zip', 'svg', 'png'];
    roles = options.user.subscriptionDetails.studio.features;
    staffPickTag = { name: 'Staff Picks', type: 'SUPER' as 'SUPER' };
    duplicating = false;

    constructor(private project: anm.Project) {}

    staffLike() {
        SpinnerSvc.show();
        this.project.staffPicked = true;
        this.TagsSvc.saveTag(this.staffPickTag, this.project.id)
            .then(() => this.project.tags.push(this.staffPickTag))
            .catch(this.errorFunction.bind(this))
            .finally(() => SpinnerSvc.hide());
    }

    staffDislike() {
        SpinnerSvc.show();
        this.project.staffPicked = false;
        this.TagsSvc.tagRemoved(this.staffPickTag, this.project.id)
            .then(() => {
                this.project.tags = this.project.tags.filter(
                    tag => tag.name !== this.staffPickTag.name
                );
            })
            .finally(() => SpinnerSvc.hide());
    }

    exportProject = (action: string) =>
        this.BackendSvc.getServerUrl(this.project).then(url => {
            const exportUrl = `${url}/project/export/${action}/${this.project.id}?params={}&t=0`;
            window.open(exportUrl, '_self');
        })

    doctor = (action: string) =>
        this.BackendSvc.getServerUrl(this.project).then(url => {
            const doctorUrl = `${url}/doctor/show/${this.project.id}`;
            window.open(doctorUrl, '_blank');
        })

    duplicateProject(folderId: number, copySuffix = 'Copy_from_website') {
        const folderParam = folderId ? `&folderId=${folderId}` : '';
        const newName = this.project.name + copySuffix;

        const params = {
            folderId,
            name: encodeURIComponent(newName),
            oldProjectId: this.project.id
        };

        const requestWrapper = (request: ng.IPromise<any>) => {
            return request
                .then(r => r.data)
                .then((data: ApiError) =>
                    Utils.isApiError(data)
                        ? this.$q.reject(data)
                        : this.$q.resolve(data)
                );
        };

        const duplicateRequest = requestWrapper(
            this.HttpSvc('project-api/duplicate').securePost(null, { params })
        );

        SpinnerSvc.show();
        this.duplicating = true;

        return duplicateRequest
            .then((project: anm.Project) => {
                this.$rootScope.$emit(PROJECT_ADD, { project });
            })
            .finally(() => {
                this.duplicating = false;
                SpinnerSvc.hide();
            });
    }

    private errorFunction(error: string) {
        console.log(error);
        _.notification.showError('Failed to modify staff picks');
    }
}

function AdminSvcFactory(
    $http: ng.IHttpService,
    $q: ng.IQService,
    $rootScope: ng.IRootScopeService,
    TagsSvc: TagsSvc,
    HttpSvc: HttpSvcFactory,
    BackendSvc: BackendSvc,
    TranslateSvc: TranslateSvc
) {
    _.extend(AdminSvc.prototype, {
        $http,
        $q,
        TagsSvc,
        HttpSvc,
        BackendSvc,
        $rootScope,
        TranslateSvc
    });
    return AdminSvc;
}

services.service('AdminSvc', AdminSvcFactory);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AdminSvc.ts